$(document).ready(function () {
  function adjustBlockHeights() {
    if ($(window).width() >= 989) {
      var maxHeight = 0;
      $(".template-page-industrial .multicolumn_title-btn-wrapper").each(
        function () {
          var blockHeight = $(this).height();
          if (blockHeight > maxHeight) {
            maxHeight = blockHeight;
          }
        }
      );
      $(".template-page-industrial .multicolumn_title-btn-wrapper").height(
        maxHeight
      );
    } else {
      $(".template-page-industrial .multicolumn_title-btn-wrapper").height(
        "auto"
      );
    }
  }
  adjustBlockHeights();
  $(window).resize(function () {
    adjustBlockHeights();
  });
  $(document).on(
    "click",
    ".read_more_with_content a.read_more_btn",
    function (e) {
      e.preventDefault();
      if ($(this).text() == "Read More >>") {
        $(this)
          .parents(".read_more_with_content")
          .find(".read_more_content_here")
          .slideDown();
        $(this).text("Read Less >>");
      } else {
        $(this)
          .parents(".read_more_with_content")
          .find(".read_more_content_here")
          .slideUp();
        $(this).text("Read More >>");
      }
    }
  );
  
  $(document).on("click", "a.button.videoButton.primaryButton", function (e) {
    e.preventDefault();
    var video_url_btn = $(this).data("video-url");
    $(this)
      .parents(".banner_outer_main_wrapp")
      .find(".videoContainer video")
      .attr("src", video_url_btn);
    $(this).parents(".banner_outer_main_wrapp").find(".videoContainer").show();
    $(this)
      .parents(".banner_outer_main_wrapp")
      .find(".videoContainer video")
      .trigger("play");
  });
  
  $(document).on("click", ".videoCloseButton", function (e) {
    e.preventDefault();
    $(this).parents(".videoContainer").find("video").removeAttr("src");
    $(this).parents(".videoContainer").find("video").trigger("pause");
    $(this).parents(".videoContainer").hide();
  });
  
  $(document).on("click", ".laboratories_page_side a", function (e) {
    e.preventDefault();
    var side_data_handle = $(this).attr("data-handle");
    $("html, body").animate(
      {
        scrollTop: $(
          ".side_bottom_rpeater_wrapp[data-handle='" + side_data_handle + "']"
        ).offset().top,
      },
      1200
    );
  });
  
  $(document).on(
    "click",
    ".custom-video-buttons.custom-left-right-buttons.new-power_all_btns a",
    function () {
      var data_handle = $(this).data("handle");
      var data_handle_2 = $(
        ".scrolling_bottom_sections[data-handle='" + data_handle + "']"
      ).html();
      if (typeof data_handle_2 !== "undefined") {
        $("html, body").animate(
          {
            scrollTop: $(
              ".scrolling_bottom_sections[data-handle='" + data_handle + "']"
            ).offset().top,
          },
          1200
        );
      }
    }
  );
  
  $(".custom_accent_col-banner .custom-video-buttons a").click(function (e) {
    e.preventDefault();
    var link_handle = $(this).attr("data-handle");
    $("html, body").animate(
      {
        scrollTop: $(
          ".custom_collection_progrid-outer[data-id='" + link_handle + "']"
        ).offset().top,
      },
      1200
    );
  });

  $(document).on(
    "click",
    ".everywhere-busstrut-heading-col h2 a",
    function (e) {
      var get_link_href = $(this).attr("href");
      if (get_link_href == "#viewemail") {
        e.preventDefault();
        gtag("event", "view_email", {
          event_category: "Email",
          event_label: "Email Clicked",
          value: 1,
        });
      }
    }
  );

  function forceVideoPlay() {
    const homeVideos = document.querySelectorAll(".template-index video");
    homeVideos.forEach((video) => {
      if (video && video.paused) {
        video.play().catch((err) => {
          console.warn("Autoplay failed:", err);
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", forceVideoPlay);
  const observer = new MutationObserver(forceVideoPlay);
  observer.observe(document.body, { childList: true, subtree: true });


});






  // Toggle popup on button click
  $('.custom_heading_wrapper').on('click', function(){

    const popup = $(this).find('.email-popup');

    // Toggle: If visible, hide it; otherwise, show it
    if (popup.is(':visible')) {
      popup.hide();
    } else {
      $('.email-popup').hide(); // close other popups if any
      popup.show();
    }
  });

  // Hide popup if clicking anywhere outside
  $(document).on('click', function(e){
    if (!$(e.target).closest('.custom_heading_wrapper').length) {
      $('.email-popup').hide();
    }
  });




    $('.hotspot').hover(function() {
      const imgHoverValue = $(this).closest('.hotspot-main').find('.hots-image').data('imghover');

      // Remove the overlay class from all
      $('li[data-hover] .card__media').removeClass('no-overlay');

      // Add the no-overlay class to the matching one
      $('li[data-hover="' + imgHoverValue + '"] .card__media').addClass('no-overlay');
    }, function() {
      // On hover out: remove the overlay control class
      $('li[data-hover] .card__media').removeClass('no-overlay');
    });







// document.addEventListener('DOMContentLoaded', function () {
//   const overlay = document.getElementById('video-overlay');
//   const closeBtn = document.getElementById('close-btn');
//   const overlayBg = document.getElementById('overlay-bg');
//   const body = document.body;
//   const videoContainer = document.getElementById('video-container');
//   const video = document.getElementById('video-player');

//   function showOverlay() {
//     overlay.style.display = 'flex';
//     body.classList.add('video-overlay-open');

//     // Try to autoplay video
//     if (video) {
//       video.currentTime = 0;
//       video.muted = true; // Ensure muted for autoplay
//       const playPromise = video.play();
//       if (playPromise !== undefined) {
//         playPromise.catch(error => {
//           console.warn('Autoplay failed:', error);
//         });
//       }
//     }
//   }

//   function dismissOverlay() {
//     overlay.style.display = 'none';
//     body.classList.remove('video-overlay-open');
//     if (video) {
//       video.pause();
//       video.currentTime = 0;
//       video.muted = true;
//     }
//   }

//   closeBtn.addEventListener('click', dismissOverlay);
//   overlayBg.addEventListener('click', dismissOverlay);

//   document.addEventListener('click', function (event) {
//     const isClickInsideVideo = videoContainer.contains(event.target);
//     const isOverlayVisible = overlay.style.display === 'flex';
//     if (!isClickInsideVideo && isOverlayVisible) {
//       dismissOverlay();
//     }
//   });

//   // Show on load
//   showOverlay();
// });



document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('video-overlay');
  const closeBtn = document.getElementById('close-btn');
  const overlayBg = document.getElementById('overlay-bg');
  const body = document.body;
  const videoContainer = document.getElementById('video-container');
  const video = document.getElementById('video-player');

  // Get cookie value
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // Set cookie with 1-day expiry
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  function showOverlay() {
    overlay.style.display = 'flex';
    body.classList.add('video-overlay-open');

    if (video) {
      video.currentTime = 0;
      video.muted = true;
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.warn('Autoplay failed:', error);
        });
      }
    }
  }

  function dismissOverlay() {
    overlay.style.display = 'none';
    body.classList.remove('video-overlay-open');
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
    }
    setCookie('videoPopupSeenToday', 'true', 1); // expires in 1 day
  }

  // Attach events
  closeBtn.addEventListener('click', dismissOverlay);
  overlayBg.addEventListener('click', dismissOverlay);
  document.addEventListener('click', function (event) {
    const isClickInsideVideo = videoContainer.contains(event.target);
    const isOverlayVisible = overlay.style.display === 'flex';
    if (!isClickInsideVideo && isOverlayVisible) {
      dismissOverlay();
    }
  });

  // Only show if cookie is not set
  if (!getCookie('videoPopupSeenToday')) {
    showOverlay();
  }
});



